/**
 * @description Country
 */
export enum Country {

    /**
     * @description Local host
     */
    LOCALHOST = 'localhost',

    /**
     * @description Anonymous Proxy
     */
    A1 = 'a1',

    /**
     * @description Satellite Provider
     */
    A2 = 'a2',

    /**
     * @description Andorra
     */
    AD = 'ad',

    /**
     * @description United Arab Emirates
     */
    AE = 'ae',

    /**
     * @description Afghanistan
     */
    AF = 'af',

    /**
     * @description Antigua and Barbuda
     */
    AG = 'ag',

    /**
     * @description Anguilla
     */
    AI = 'ai',

    /**
     * @description Albania
     */
    AL = 'al',

    /**
     * @description Armenia
     */
    AM = 'am',

    /**
     * @description Angola
     */
    AO = 'ao',

    /**
     * @description Asia/Pacific Region
     */
    AP = 'ap',

    /**
     * @description Antarctica
     */
    AQ = 'aq',

    /**
     * @description Argentina
     */
    AR = 'ar',

    /**
     * @description American Samoa
     */
    AS = 'as',

    /**
     * @description Austria
     */
    AT = 'at',

    /**
     * @description Australia
     */
    AU = 'au',

    /**
     * @description Aruba
     */
    AW = 'aw',

    /**
     * @description Aland Islands
     */
    AX = 'ax',

    /**
     * @description Azerbaijan
     */
    AZ = 'az',

    /**
     * @description Bosnia and Herzegovina
     */
    BA = 'ba',

    /**
     * @description Barbados
     */
    BB = 'bb',

    /**
     * @description Bangladesh
     */
    BD = 'bd',

    /**
     * @description Belgium
     */
    BE = 'be',

    /**
     * @description Burkina Faso
     */
    BF = 'bf',

    /**
     * @description Bulgaria
     */
    BG = 'bg',

    /**
     * @description Bahrain
     */
    BH = 'bh',

    /**
     * @description Burundi
     */
    BI = 'bi',

    /**
     * @description Benin
     */
    BJ = 'bj',

    /**
     * @description Saint Bartelemey
     */
    BL = 'bl',

    /**
     * @description Bermuda
     */
    BM = 'bm',

    /**
     * @description Brunei Darussalam
     */
    BN = 'bn',

    /**
     * @description Bolivia
     */
    BO = 'bo',

    /**
     * @description Bonaire, Saint Eustatius and Saba
     */
    BQ = 'bq',

    /**
     * @description Brazil
     */
    BR = 'br',

    /**
     * @description Bahamas
     */
    BS = 'bs',

    /**
     * @description Bhutan
     */
    BT = 'bt',

    /**
     * @description Bouvet Island
     */
    BV = 'bv',

    /**
     * @description Botswana
     */
    BW = 'bw',

    /**
     * @description Belarus
     */
    BY = 'by',

    /**
     * @description Belize
     */
    BZ = 'bz',

    /**
     * @description Canada
     */
    CA = 'ca',

    /**
     * @description Cocos (Keeling) Islands
     */
    CC = 'cc',

    /**
     * @description Congo, The Democratic Republic of the
     */
    CD = 'cd',

    /**
     * @description Central African Republic
     */
    CF = 'cf',

    /**
     * @description Congo
     */
    CG = 'cg',

    /**
     * @description Switzerland
     */
    CH = 'ch',

    /**
     * @description Cote d'Ivoire
     */
    CI = 'ci',

    /**
     * @description Cook Islands
     */
    CK = 'ck',

    /**
     * @description Chile
     */
    CL = 'cl',

    /**
     * @description Cameroon
     */
    CM = 'cm',

    /**
     * @description China
     */
    CN = 'cn',

    /**
     * @description Colombia
     */
    CO = 'co',

    /**
     * @description Costa Rica
     */
    CR = 'cr',

    /**
     * @description Cuba
     */
    CU = 'cu',

    /**
     * @description Cape Verde
     */
    CV = 'cv',

    /**
     * @description Curacao
     */
    CW = 'cw',

    /**
     * @description Christmas Island
     */
    CX = 'cx',

    /**
     * @description Cyprus
     */
    CY = 'cy',

    /**
     * @description Czech Republic
     */
    CZ = 'cz',

    /**
     * @description Germany
     */
    DE = 'de',

    /**
     * @description Djibouti
     */
    DJ = 'dj',

    /**
     * @description Denmark
     */
    DK = 'dk',

    /**
     * @description Dominica
     */
    DM = 'dm',

    /**
     * @description Dominican Republic
     */
    DO = 'do',

    /**
     * @description Algeria
     */
    DZ = 'dz',

    /**
     * @description Ecuador
     */
    EC = 'ec',

    /**
     * @description Estonia
     */
    EE = 'ee',

    /**
     * @description Egypt
     */
    EG = 'eg',

    /**
     * @description Western Sahara
     */
    EH = 'eh',

    /**
     * @description Eritrea
     */
    ER = 'er',

    /**
     * @description Spain
     */
    ES = 'es',

    /**
     * @description Ethiopia
     */
    ET = 'et',

    /**
     * @description Europe
     */
    EU = 'eu',

    /**
     * @description Finland
     */
    FI = 'fi',

    /**
     * @description Fiji
     */
    FJ = 'fj',

    /**
     * @description Falkland Islands (Malvinas)
     */
    FK = 'fk',

    /**
     * @description Micronesia, Federated States of
     */
    FM = 'fm',

    /**
     * @description Faroe Islands
     */
    FO = 'fo',

    /**
     * @description France
     */
    FR = 'fr',

    /**
     * @description Gabon
     */
    GA = 'ga',

    /**
     * @description United Kingdom
     */
    GB = 'gb',

    /**
     * @description Grenada
     */
    GD = 'gd',

    /**
     * @description Georgia
     */
    GE = 'ge',

    /**
     * @description French Guiana
     */
    GF = 'gf',

    /**
     * @description Guernsey
     */
    GG = 'gg',

    /**
     * @description Ghana
     */
    GH = 'gh',

    /**
     * @description Gibraltar
     */
    GI = 'gi',

    /**
     * @description Greenland
     */
    GL = 'gl',

    /**
     * @description Gambia
     */
    GM = 'gm',

    /**
     * @description Guinea
     */
    GN = 'gn',

    /**
     * @description Guadeloupe
     */
    GP = 'gp',

    /**
     * @description Equatorial Guinea
     */
    GQ = 'gq',

    /**
     * @description Greece
     */
    GR = 'gr',

    /**
     * @description South Georgia and the South Sandwich Islands
     */
    GS = 'gs',

    /**
     * @description Guatemala
     */
    GT = 'gt',

    /**
     * @description Guam
     */
    GU = 'gu',

    /**
     * @description Guinea-Bissau
     */
    GW = 'gw',

    /**
     * @description Guyana
     */
    GY = 'gy',

    /**
     * @description Hong Kong
     */
    HK = 'hk',

    /**
     * @description Heard Island and McDonald Islands
     */
    HM = 'hm',

    /**
     * @description Honduras
     */
    HN = 'hn',

    /**
     * @description Croatia
     */
    HR = 'hr',

    /**
     * @description Haiti
     */
    HT = 'ht',

    /**
     * @description Hungary
     */
    HU = 'hu',

    /**
     * @description Indonesia
     */
    ID = 'id',

    /**
     * @description Ireland
     */
    IE = 'ie',

    /**
     * @description Israel
     */
    IL = 'il',

    /**
     * @description Isle of Man
     */
    IM = 'im',

    /**
     * @description India
     */
    IN = 'in',

    /**
     * @description British Indian Ocean Territory
     */
    IO = 'io',

    /**
     * @description Iraq
     */
    IQ = 'iq',

    /**
     * @description Iran, Islamic Republic of
     */
    IR = 'ir',

    /**
     * @description Iceland
     */
    IS = 'is',

    /**
     * @description Italy
     */
    IT = 'it',

    /**
     * @description Jersey
     */
    JE = 'je',

    /**
     * @description Jamaica
     */
    JM = 'jm',

    /**
     * @description Jordan
     */
    JO = 'jo',

    /**
     * @description Japan
     */
    JP = 'jp',

    /**
     * @description Kenya
     */
    KE = 'ke',

    /**
     * @description Kyrgyzstan
     */
    KG = 'kg',

    /**
     * @description Cambodia
     */
    KH = 'kh',

    /**
     * @description Kiribati
     */
    KI = 'ki',

    /**
     * @description Comoros
     */
    KM = 'km',

    /**
     * @description Saint Kitts and Nevis
     */
    KN = 'kn',

    /**
     * @description Korea, Democratic People's Republic of
     */
    KP = 'kp',

    /**
     * @description Korea, Republic of
     */
    KR = 'kr',

    /**
     * @description Kuwait
     */
    KW = 'kw',

    /**
     * @description Cayman Islands
     */
    KY = 'ky',

    /**
     * @description Kazakhstan
     */
    KZ = 'kz',

    /**
     * @description Lao People's Democratic Republic
     */
    LA = 'la',

    /**
     * @description Lebanon
     */
    LB = 'lb',

    /**
     * @description Saint Lucia
     */
    LC = 'lc',

    /**
     * @description Liechtenstein
     */
    LI = 'li',

    /**
     * @description Sri Lanka
     */
    LK = 'lk',

    /**
     * @description Liberia
     */
    LR = 'lr',

    /**
     * @description Lesotho
     */
    LS = 'ls',

    /**
     * @description Lithuania
     */
    LT = 'lt',

    /**
     * @description Luxembourg
     */
    LU = 'lu',

    /**
     * @description Latvia
     */
    LV = 'lv',

    /**
     * @description Libyan Arab Jamahiriya
     */
    LY = 'ly',

    /**
     * @description Morocco
     */
    MA = 'ma',

    /**
     * @description Monaco
     */
    MC = 'mc',

    /**
     * @description Moldova, Republic of
     */
    MD = 'md',

    /**
     * @description Montenegro
     */
    ME = 'me',

    /**
     * @description Saint Martin
     */
    MF = 'mf',

    /**
     * @description Madagascar
     */
    MG = 'mg',

    /**
     * @description Marshall Islands
     */
    MH = 'mh',

    /**
     * @description Macedonia
     */
    MK = 'mk',

    /**
     * @description Mali
     */
    ML = 'ml',

    /**
     * @description Myanmar
     */
    MM = 'mm',

    /**
     * @description Mongolia
     */
    MN = 'mn',

    /**
     * @description Macao
     */
    MO = 'mo',

    /**
     * @description Northern Mariana Islands
     */
    MP = 'mp',

    /**
     * @description Martinique
     */
    MQ = 'mq',

    /**
     * @description Mauritania
     */
    MR = 'mr',

    /**
     * @description Montserrat
     */
    MS = 'ms',

    /**
     * @description Malta
     */
    MT = 'mt',

    /**
     * @description Mauritius
     */
    MU = 'mu',

    /**
     * @description Maldives
     */
    MV = 'mv',

    /**
     * @description Malawi
     */
    MW = 'mw',

    /**
     * @description Mexico
     */
    MX = 'mx',

    /**
     * @description Malaysia
     */
    MY = 'my',

    /**
     * @description Mozambique
     */
    MZ = 'mz',

    /**
     * @description Namibia
     */
    NA = 'na',

    /**
     * @description New Caledonia
     */
    NC = 'nc',

    /**
     * @description Niger
     */
    NE = 'ne',

    /**
     * @description Norfolk Island
     */
    NF = 'nf',

    /**
     * @description Nigeria
     */
    NG = 'ng',

    /**
     * @description Nicaragua
     */
    NI = 'ni',

    /**
     * @description Netherlands
     */
    NL = 'nl',

    /**
     * @description Norway
     */
    NO = 'no',

    /**
     * @description Nepal
     */
    NP = 'np',

    /**
     * @description Nauru
     */
    NR = 'nr',

    /**
     * @description Niue
     */
    NU = 'nu',

    /**
     * @description New Zealand
     */
    NZ = 'nz',

    /**
     * @description Other Country
     */
    O1 = 'o1',

    /**
     * @description Oman
     */
    OM = 'om',

    /**
     * @description Panama
     */
    PA = 'pa',

    /**
     * @description Peru
     */
    PE = 'pe',

    /**
     * @description French Polynesia
     */
    PF = 'pf',

    /**
     * @description Papua New Guinea
     */
    PG = 'pg',

    /**
     * @description Philippines
     */
    PH = 'ph',

    /**
     * @description Pakistan
     */
    PK = 'pk',

    /**
     * @description Poland
     */
    PL = 'pl',

    /**
     * @description Saint Pierre and Miquelon
     */
    PM = 'pm',

    /**
     * @description Pitcairn
     */
    PN = 'pn',

    /**
     * @description Puerto Rico
     */
    PR = 'pr',

    /**
     * @description Palestinian Territory
     */
    PS = 'ps',

    /**
     * @description Portugal
     */
    PT = 'pt',

    /**
     * @description Palau
     */
    PW = 'pw',

    /**
     * @description Paraguay
     */
    PY = 'py',

    /**
     * @description Qatar
     */
    QA = 'qa',

    /**
     * @description Reunion
     */
    RE = 're',

    /**
     * @description Romania
     */
    RO = 'ro',

    /**
     * @description Serbia
     */
    RS = 'rs',

    /**
     * @description Russian Federation
     */
    RU = 'ru',

    /**
     * @description Rwanda
     */
    RW = 'rw',

    /**
     * @description Saudi Arabia
     */
    SA = 'sa',

    /**
     * @description Solomon Islands
     */
    SB = 'sb',

    /**
     * @description Seychelles
     */
    SC = 'sc',

    /**
     * @description Sudan
     */
    SD = 'sd',

    /**
     * @description Sweden
     */
    SE = 'se',

    /**
     * @description Singapore
     */
    SG = 'sg',

    /**
     * @description Saint Helena
     */
    SH = 'sh',

    /**
     * @description Slovenia
     */
    SI = 'si',

    /**
     * @description Svalbard and Jan Mayen
     */
    SJ = 'sj',

    /**
     * @description Slovakia
     */
    SK = 'sk',

    /**
     * @description Sierra Leone
     */
    SL = 'sl',

    /**
     * @description San Marino
     */
    SM = 'sm',

    /**
     * @description Senegal
     */
    SN = 'sn',

    /**
     * @description Somalia
     */
    SO = 'so',

    /**
     * @description Suriname
     */
    SR = 'sr',

    /**
     * @description South Sudan
     */
    SS = 'ss',

    /**
     * @description Sao Tome and Principe
     */
    ST = 'st',

    /**
     * @description El Salvador
     */
    SV = 'sv',

    /**
     * @description Sint Maarten
     */
    SX = 'sx',

    /**
     * @description Syrian Arab Republic
     */
    SY = 'sy',

    /**
     * @description Swaziland
     */
    SZ = 'sz',

    /**
     * @description Turks and Caicos Islands
     */
    TC = 'tc',

    /**
     * @description Chad
     */
    TD = 'td',

    /**
     * @description French Southern Territories
     */
    TF = 'tf',

    /**
     * @description Togo
     */
    TG = 'tg',

    /**
     * @description Thailand
     */
    TH = 'th',

    /**
     * @description Tajikistan
     */
    TJ = 'tj',

    /**
     * @description Tokelau
     */
    TK = 'tk',

    /**
     * @description Timor-Leste
     */
    TL = 'tl',

    /**
     * @description Turkmenistan
     */
    TM = 'tm',

    /**
     * @description Tunisia
     */
    TN = 'tn',

    /**
     * @description Tonga
     */
    TO = 'to',

    /**
     * @description Turkey
     */
    TR = 'tr',

    /**
     * @description Trinidad and Tobago
     */
    TT = 'tt',

    /**
     * @description Tuvalu
     */
    TV = 'tv',

    /**
     * @description Taiwan
     */
    TW = 'tw',

    /**
     * @description Tanzania, United Republic of
     */
    TZ = 'tz',

    /**
     * @description Ukraine
     */
    UA = 'ua',

    /**
     * @description Uganda
     */
    UG = 'ug',

    /**
     * @description United States Minor Outlying Islands
     */
    UM = 'um',

    /**
     * @description United States
     */
    US = 'us',

    /**
     * @description Uruguay
     */
    UY = 'uy',

    /**
     * @description Uzbekistan
     */
    UZ = 'uz',

    /**
     * @description Holy See (Vatican City State)
     */
    VA = 'va',

    /**
     * @description Saint Vincent and the Grenadines
     */
    VC = 'vc',

    /**
     * @description Venezuela
     */
    VE = 've',

    /**
     * @description Virgin Islands, British
     */
    VG = 'vg',

    /**
     * @description Virgin Islands, U.S.
     */
    VI = 'vi',

    /**
     * @description Vietnam
     */
    VN = 'vn',

    /**
     * @description Vanuatu
     */
    VU = 'vu',

    /**
     * @description Wallis and Futuna
     */
    WF = 'wf',

    /**
     * @description Samoa
     */
    WS = 'ws',

    /**
     * @description No Country
     */
    XX = 'xx',

    /**
     * @description Yemen
     */
    YE = 'ye',

    /**
     * @description Mayotte
     */
    YT = 'yt',

    /**
     * @description South Africa
     */
    ZA = 'za',

    /**
     * @description Zambia
     */
    ZM = 'zm',

    /**
     * @description Zimbabwe
     */
    ZW = 'zw',

}